module.exports = __webpack_public_path__ + "img/footer-logo.9787a35714848f2b7c5bffc9fae2ad7d.png";